import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react.js';

export default class IntencaoRegistroPrecoLista extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    searchWithPage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
  };

  onViewDetalhes = irp => {
    this.props.history.push(`/irp/${irp.get('id')}`);
  };

  renderIrp = irp => (
    <TableActions
      ref="row"
      key={irp.get('id')}
      data={irp}
      onMore={this.onViewDetalhes}
    >
      <td id="tdNumeroAno">{`${irp.get('numero')}/${irp.get('ano')}`}</td>
      <td id="tdModalidade">{irp.get('modalidadeDescricao')}</td>
      <td id="tdObjeto">{irp.get('objeto')}</td>
      <td id="tdDataFimInteresse">
        {DateUtils.formatDateTime(
          irp.get('dataFimInteresse'),
          'DD/MM/YYYY HH:mm'
        )}
      </td>
    </TableActions>
  );

  render() {
    const { page, searchWithPage } = this.props;
    const irps = page.get('content');

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader
            empty={irps.isEmpty()}
            text="Não foi encontrada nenhuma IRP para a pesquisa selecionada."
          >
            <tr>
              <TableHeaderItem
                field="numero"
                label="Número/Ano"
                page={page}
                searchWithPage={searchWithPage}
              />
              <th>Modalidade</th>
              <th>Objeto</th>
              <TableHeaderItem
                field="dataFimInteresse"
                label="Data Final de Manifestação de Interesse"
                page={page}
                searchWithPage={searchWithPage}
              />
              <th />
            </tr>
          </TableHeader>
          <tbody>{irps.map(this.renderIrp)}</tbody>
        </table>
      </div>
    );
  }
}
